import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/drama" },
  { label: "综艺", to: "/category/variety" },
  { label: "短视频", to: "/category/short" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="flex items-center gap-4 px-4 md:px-8 h-16">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-play-fill text-xl"></i>
          </span>
          <span className="font-heading font-bold text-xl text-foreground-950 tracking-tight">
            在线视频
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1 ml-2">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? "text-primary-600 bg-primary-50"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Desktop search */}
        <form
          onSubmit={handleSearch}
          className="hidden md:flex items-center ml-auto max-w-xs w-full"
        >
          <div className="relative w-full">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              placeholder="搜索视频、剧集、综艺"
              className="w-full pl-9 pr-3 py-2 text-sm rounded-md bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50"
            />
          </div>
        </form>

        {/* Mobile actions */}
        <div className="flex items-center gap-2 ml-auto md:ml-0">
          <Link
            to="/search"
            aria-label="搜索"
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-search-line text-lg"></i>
          </Link>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <form onSubmit={handleSearch} className="px-4 pt-3">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="text"
                placeholder="搜索视频、剧集、综艺"
                className="w-full pl-9 pr-3 py-2.5 text-sm rounded-md bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
              />
            </div>
          </form>
          <nav className="flex flex-col px-2 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-base font-medium cursor-pointer ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <NavLink
              to="/about"
              className="px-3 py-3 rounded-md text-base font-medium text-foreground-700 cursor-pointer"
            >
              关于我们
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
}